
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";

const ResetPassword = () => {
  return <ResetPasswordForm />;
};

export default ResetPassword;
